const KeyWordLocalization = {
    TRADE_MARK: 'TRADE_MARK',
    edit: "edit",
    Search: "Search",

    //#region---------------------- Pages ----------------------//
    SignInPageSuccess: "SignInPageSuccess",
    SignInPageTitle: "SignInPageTitle",
    SignInPageSubtitle: "SignInPageSubtitle",
    SignInPageEmail: "SignInPageEmail",
    SignInPagePassword: "SignInPagePassword",
    SignInPageButtonSignIn: "SignInPageButtonSignIn",

    QrListPageQuery: "QrListPageQuery",
    QrListCurrentPage: "QrListCurrentPage",
    QrListPageStatusQuery: "QrListPageStatusQuery",
    QrListPageSearch: "QrListPageSearch",
    QrListPageActions: "QrListPageActions",
    QrListPageAddQr: "QrListPageAddQr",
    QrListPageStablishment: "QrListPageStablishment",

    UserListTitle: "UserListTitle",
    UserListPageQuery: "UserListPageQuery",
    UserListPageRoleQuery: "UserListPageRoleQuery",
    UserListCurrentPage: "UserListCurrentPage",
    UserListPageSearchInput: "UserListPageSearchInput",
    UserListTotalPages: "UserListTotalPages",
    UserListPageSearch: "UserListPageSearch",
    UserListPageId: "UserListPageId",
    UserListPageName: "UserListPageName",
    UserListPageActions: "UserListPageActions",
    UserListPageActionEdit: "UserListPageActionEdit",
    UserListPageActionDelete: "UserListPageActionDelete",
    UserListPageAddUser: "UserListPageAddUser",
    UserListPageDeleteSuccess: "UserListPageDeleteSuccess",
    UserListDeleteModalTitle: "UserListDeleteModalTitle",
    UserListDeleteModalSubtitle: "UserListDeleteModalSubtitle",

    CreateUserPageTitle: "CreateUserPageTitle",
    CreateUserPageAddQuestion: "CreateUserPageAddQuestion",
    CreateUserPageCreateError: "CreateUserPageCreateError",
    CreateUserPageCreateSuccess: "CreateUserPageCreateSuccess",
    CreateUserPageQuestionAdded: "CreateUserPageQuestionAdded",
    CreateUserPageCreateQuestion: "CreateUserPageCreateQuestion",
    CreateUserPageQuestionUpdated: "CreateUserPageQuestionUpdated",
    CreateUserPageEditQuestion: "CreateUserPageEditQuestion",
    CreateUserPageEditTitle: "CreateUserPageEditTitle",
    CreateUserPageAddTitle: "CreateUserPageAddTitle",
    CreateUserPageQuestionsTitle: "CreateUserPageQuestionsTitle",
    CreateUserPageNoQuestions: "CreateUserPageNoQuestions",
    CreateUserPageQuestionPoints: "CreateUserPageQuestionPoints",
    CreateUserPageDelete: "CreateUserPageDelete",
    CreateUserPageEdit: "CreateUserPageEdit",
    CreateUserUpdate: "CreateUserUpdate",
    CreateUserCreate: "CreateUserCreate",
    CreateUserPageUpdateError: "CreateUserPageUpdateError",
    CreateUserPageUpdateSuccess: "CreateUserPageUpdateSuccess",
    CreateUserPageQuestionDeleted: "CreateUserPageQuestionDeleted",
    CreateUserPageDeleteQuestionTitle: "CreateUserPageDeleteQuestionTitle",
    CreateUserPageDeleteQuestionSubtitle: "CreateUserPageDeleteQuestionSubtitle",
    CreateUserPageQuestionError: "CreateUserPageQuestionError",

    DetailedUserPageTitle: "DetailedUserPageTitle",
    DetailedUserPageQuestions: "DetailedUserPageQuestions",
    DetailedUserPagePoints: "DetailedUserPagePoints",

    DashboardPageOpTypeForm: "DashboardPageOpTypeForm",
    DashboardPageDateFromForm: "DashboardPageDateFromForm",
    DashboardPageDateToForm: "DashboardPageDateToForm",
    DashboardPageSentimentNegative: "DashboardPageSentimentNegative",
    DashboardPageSentimentNeutral: "DashboardPageSentimentNeutral",
    DashboardPageSentimentPositive: "DashboardPageSentimentPositive",
    DashboardPageUrlParamOptype: "DashboardPageUrlParamOptype",
    DashboardPageUrlParamDateFrom: "DashboardPageUrlParamDateFrom",
    DashboardPageUrlParamDateTo: "DashboardPageUrlParamDateTo",
    DashboardPageTotalCalls: "DashboardPageTotalCalls",
    DashboardPageAverageCallScore: "DashboardPageAverageCallScore",
    DashboardPageAverageUserScore: "DashboardPageAverageUserScore",
    DashboardPageAverageCustomerScore: "DashboardPageAverageCustomerScore",
    DashboardPageSentimentsOnTime: "DashboardPageSentimentsOnTime",
    DashboardPageReasonsForCall: "DashboardPageReasonsForCall",
    DashboardPageBestClients: "DashboardPageBestClients",
    DashboardPageWorstClients: "DashboardPageWorstClients",
    //#endregion---------------------- Pages ----------------------//

    //#region---------------------- Components ----------------------//
    ModalCustomCompoonentCloseButton: "ModalCustomCompoonentCloseButton",

    LoadingComponentLoading: "LoadingComponentLoading",

    AuthIfonComponentRevolutionTitle: "AuthIfonComponentRevolutionTitle",
    AuthIfonComponentRevolutionSubitle: "AuthIfonComponentRevolutionSubitle",
    AuthIfonComponentAIPoweredTitle: "AuthIfonComponentAIPoweredTitle",
    AuthIfonComponentAIPoweredSubitle: "AuthIfonComponentAIPoweredSubitle",
    AuthIfonComponentFastTitle: "AuthIfonComponentFastTitle",
    AuthIfonComponentFastSubtitle: "AuthIfonComponentFastSubtitle",
    AuthIfonComponentBoostTitle: "AuthIfonComponentBoostTitle",
    AuthIfonComponentBoostSubtitle: "AuthIfonComponentBoostSubtitle",

    PaginatorComponentShowing: "PaginatorComponentShowing", //showing, total

    DeleteModalComponentConfirm: "DeleteModalComponentConfirm",
    DeleteModalComponentCancel: "DeleteModalComponentCancel",
    DeleteModalComponentDelete: "DeleteModalComponentDelete",
    DeleteModalComponentMessage: "DeleteModalComponentMessage",
    DeleteModalComponentError: "DeleteModalComponentError",

    CreateQuestionComponentDescription: "CreateQuestionComponentDescription",
    CreateQuestionComponentPoints: "CreateQuestionComponentPoints",
    CreateQuestionComponentTitle: "CreateQuestionComponentTitle",
    CreateQuestionComponentSave: "CreateQuestionComponentSave",
    CreateQuestionComponentCancel: "CreateQuestionComponentCancel",
    CreateQuestionComponentCreate: "CreateQuestionComponentCreate",

    NotFoundComponentTitle: "NotFoundComponentTitle",
    NotFoundComponentSubtitle: "NotFoundComponentSubtitle",

    AudioZoneComponentAudioUploaded: "AudioZoneComponentAudioUploaded",
    AudioZoneComponentResultTitle: "AudioZoneComponentResultTitle",
    AudioZoneComponentTitle: "AudioZoneComponentTitle",
    AudioZoneComponentDropHere: "AudioZoneComponentDropHere",
    AudioZoneComponentJustDrop: "AudioZoneComponentJustDrop",
    AudioZoneComponentLoadingAudio: "AudioZoneComponentLoadingAudio",

    TargetCircleComponentServiceTarget: "TargetCircleComponentServiceTarget",

    TableSatisfactionComponentTitleClient: "TableSatisfactionComponentTitleClient",
    TableSatisfactionComponentTitleOPType: "TableSatisfactionComponentTitleOPType",
    TableSatisfactionComponentTotalCalls: "TableSatisfactionComponentTotalCalls",
    TableSatisfactionComponentSentiments: "TableSatisfactionComponentSentiments",
    TableSatisfactionComponentDetails: "TableSatisfactionComponentDetails",
    TableSatisfactionErrorGettingDetail: "TableSatisfactionErrorGettingDetail",
    TableSatisfactionDetailClient: "TableSatisfactionDetailClient", //name
    //#endregion---------------------- Components ----------------------//
    
    //#region---------------------- Use Cases ----------------------//
    CheckAudioWithQuestionsUseCaseLoadingAudio: "CheckAudioWithQuestionsUseCaseLoadingAudio",
    CheckAudioWithQuestionsUseCaseUploadingAudio: "CheckAudioWithQuestionsUseCaseUploadingAudio",
    CheckAudioWithQuestionsUseCaseUploadedAudio: "CheckAudioWithQuestionsUseCaseUploadedAudio",
    CheckAudioWithQuestionsUseCaseSendingQuestions: "CheckAudioWithQuestionsUseCaseSendingQuestions",
    CheckAudioWithQuestionsUseCaseCreatingPetiton: "CheckAudioWithQuestionsUseCaseCreatingPetiton",
    CheckAudioWithQuestionsUseCaseErrorCreatedPetiton: "CheckAudioWithQuestionsUseCaseErrorCreatedPetiton",
    CheckAudioWithQuestionsUseCaseProcessingPetiton: "CheckAudioWithQuestionsUseCaseProcessingPetiton",
    CheckAudioWithQuestionsUseCaseErrorProcessingQuestions: "CheckAudioWithQuestionsUseCaseErrorProcessingQuestions",
    CheckAudioWithQuestionsUseCaseErrorUploadingAudio: "CheckAudioWithQuestionsUseCaseErrorUploadingAudio",
    CheckAudioWithQuestionsUseCaseProcessingQuestions: "CheckAudioWithQuestionsUseCaseProcessingQuestions",
    CheckAudioWithQuestionsUseCaseDone: "CheckAudioWithQuestionsUseCaseDone",
    //#endregion---------------------- Use Cases ----------------------//

    //#region---------------------- VALIDATORS ----------------------//
    ValidatorRequired: 'ValidatorRequired',
    ValidatorEmail: 'ValidatorEmail',
    ValidatorMinLength: 'ValidatorMinLength',
    ValidatorMaxLength: 'ValidatorMaxLength',
    ValidatorMinValue: 'ValidatorMinValue',
    ValidatorMaxValue: 'ValidatorMaxValue',
    ValidatorMustBeNumber: 'ValidatorMustBeNumber',
    ValidatorSpecialCharactersIsRequired: 'ValidatorSpecialCharactersIsRequired',
    ValidatorUpperCaseIsRequired: 'ValidatorUpperCaseIsRequired',
    ValidatorLowerCaseIsRequired: 'ValidatorLowerCaseIsRequired',
    ValidatorNumberIsRequired: 'ValidatorNumberIsRequired',
    ValidatorMustBeEqual: 'ValidatorMustBeEqual',
    ValidatorSpecialCharacterIsNotAllowed: 'ValidatorSpecialCharacterIsNotAllowed',
    ValidatorUpperCaseIsNotAllowed: 'ValidatorUpperCaseIsNotAllowed',
    ValidatorLowerCaseIsNotAllowed: 'ValidatorLowerCaseIsNotAllowed',
    ValidatorNumberIsNotAllowed: 'ValidatorNumberIsNotAllowed',
    ValidatorIsNotName: 'ValidatorIsNotName',
    ValidatorIsNotPhone: 'ValidatorIsNotPhone',
    ValidatorGreaterThan: 'ValidatorGreaterThan', //value
    ValidatorLessThan: 'ValidatorLessThan', //value
    ValidatorMustHavePartBeforeAt: 'ValidatorMustHavePartBeforeAt',
    ValidatorGreaterOrEqualThan: 'ValidatorGreaterOrEqualThan', //value
    ValidatorMinTime: "ValidatorMinTime", //value
    ValidatorMaxTime : "ValidatorMaxTime", //value    //#endregion---------------------- VALIDATORS ----------------------//

    //#region---------------------- UTILS ----------------------//
    january: 'january',
    february: 'february',
    march: 'march',
    april: 'april',
    may: 'may',
    june: 'june',
    july: 'july',
    august: 'august',
    september: 'september',
    october: 'october',
    november: 'november',
    december: 'december',
    //#endregion---------------------- UTILS ----------------------//

    //#region---------------------- Others ----------------------//
    UnknownError: 'UnknownError',
    ErrorServerWrongPassword: "ErrorServerWrongPassword",
    ErrorHostInvalidUsernameOrPassword: "ErrorHostInvalidUsernameOrPassword",
    ErrorHostundefined: "ErrorHostundefined",
    ErrorUnauthorized: "ErrorUnauthorized",

    SuccessDownloadWithErrors: "SuccessDownloadWithErrors",
    
    // Valet Report Page
    ValetReportPageValet: "ValetReportPageValet",
    ValetReportPageStartDate: "ValetReportPageStartDate",
    ValetReportPageEndDate: "ValetReportPageEndDate",
    
    // Reasign Shift Modal
    ReasignShiftModalUser: "ReasignShiftModalUser",
    //#endregion---------------------- Others ----------------------//

}

export default KeyWordLocalization;